import React from 'react';
import { Link } from 'react-router-dom';
import { Arrow } from '../components/Icons';

export default function NotFound() {
  return (
    <section className="section page-intro">
      <h1>Page not found.</h1>
      <Link className="underlined-link" to="/">Return to overview <Arrow /></Link>
    </section>
  );
}
